import { render, staticRenderFns } from "./SafetyCheckBasicInfo.vue?vue&type=template&id=bbc906c6&scoped=true"
import script from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js"
export * from "./SafetyCheckBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc906c6",
  null
  
)

export default component.exports